// extracted by mini-css-extract-plugin
export default {"wrapper":"SliceTooltip_wrapper__gmCCK"};